import React from 'react';
import { motion } from 'framer-motion';
export function AgitationSection() {
  return <section className="py-24 md:py-32 container mx-auto px-6 md:px-12" data-id="element-12">
      <div className="flex flex-col md:flex-row items-center gap-16 lg:gap-24" data-id="element-13">
        <motion.div className="w-full md:w-1/2" initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-14">
          <h2 className="font-serif text-4xl md:text-5xl mb-8 leading-tight" data-id="element-15">
            The Real Cost of a <br data-id="element-16" />
            <span className="text-gold italic" data-id="element-17">Bad Haircut</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold mb-8" data-id="element-18"></div>
          <p className="text-white/70 text-lg leading-relaxed font-light" data-id="element-19">
            You've walked out of a barbershop knowing something was off. The
            uneven fade. The crooked line-up. The feeling of paying for
            mediocrity.
            <br data-id="element-20" />
            <br data-id="element-21" />A bad haircut doesn't just cost you money — it costs you
            confidence, first impressions, and the version of yourself you
            deserve to present to the world.
          </p>
        </motion.div>
        <motion.div className="w-full md:w-1/2" initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-22">
          <div className="relative rounded-sm overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-23">
            <div className="absolute inset-0 bg-gold/5 mix-blend-overlay z-10 pointer-events-none" data-id="element-24"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mjYDdFyFMjSDAAzKdBxXFa/Imagen_1.webp" alt="Barber shaving client" className="w-full h-auto object-cover aspect-[4/5] md:aspect-square hover:scale-105 transition-transform duration-1000" data-id="element-25" />
          </div>
        </motion.div>
      </div>
    </section>;
}